export default __webpack_public_path__ + "static/high_back-d0036a660d2ae2e9be116112e2077f58.webp";